import { Button, Col, Row, Container, Form } from "react-bootstrap";
import Header from "./Header";
import "./Contact.css";
import { useState } from "react";
import Footer from "./Footer";
import { ReactComponent as Email } from "../assets/images/email.svg";
import { ReactComponent as Location } from "../assets/images/location.svg";
import { ReactComponent as Phone } from "../assets/images/telephone.svg";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";

function ContactUs() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    console.log("Form Values:", formValues);
    setFormValues({
      fullName: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  //   const handleSubmit = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .send(
  //       "YOUR_SERVICE_ID",
  //       "YOUR_TEMPLATE_ID",
  //       {
  //         from_name: formValues.fullName,
  //         from_email: formValues.email,
  //         subject: formValues.subject,
  //         message: formValues.message,
  //       },
  //       "YOUR_PUBLIC_KEY"
  //     )
  //     .then(() => {
  //       alert("Message sent successfully!");

  //       setFormValues({
  //         fullName: "",
  //         email: "",
  //         subject: "",
  //         message: "",
  //       });
  //     })
  //     .catch((error) => {
  //       alert("Failed to send message");
  //       console.log(error);
  //     });
  // };

  return (
    <>
      <div className="contact-v2">
        <div style={{ height: "130px" }}>
          <Header />
        </div>

        <Container className="contact-v2-header">
          <div className="contact-v2-titleWrap">
            {/* <div className="contact-v2-titleBg">CONTACT</div> */}
            <h1 className="contact-v2-title">Contact</h1>
          </div>
          <p className="contact-v2-subtitle">
            Have questions or a project in mind? Let’s connect.
          </p>
        </Container>

        <Container className="contact-v2-body">
          <Row className="g-4 ">
            <Col lg={6} md={12} className="d-flex">
              <div className="contact-v2-panel w-100">
                <div className="contact-v2-panelInner h-100 d-flex flex-column">
                  <div className="contact-v2-infoRow">
                    <div className="contact-v2-icon">
                      <Location
                        style={{
                          height: 18,
                          width: 18,
                          fill: "var(--primary)",
                        }}
                      />
                    </div>
                    <div>
                      <div className="contact-v2-label">Location:</div>
                      <div className="contact-v2-value">
                        135, Tulsi Arcade, Near Sudama Chowk, Mota Varachha,
                        Surat, Gujarat - 394101
                      </div>
                    </div>
                  </div>

                  <div className="contact-v2-infoRow">
                    <div className="contact-v2-icon">
                      <Email
                        style={{
                          height: 18,
                          width: 18,
                          fill: "var(--primary)",
                        }}
                      />
                    </div>
                    <div>
                      <div className="contact-v2-label">Email:</div>
                      <div className="contact-v2-value">
                        info@lyrainfotech.com
                      </div>
                    </div>
                  </div>

                  <div className="contact-v2-infoRow">
                    <div className="contact-v2-icon">
                      <Phone
                        style={{
                          height: 18,
                          width: 18,
                          fill: "var(--primary)",
                          stroke: "var(--primary)",
                        }}
                      />
                    </div>
                    <div>
                      <div className="contact-v2-label">Call:</div>
                      <div className="contact-v2-value">+91 9825571557</div>
                    </div>
                  </div>

                  <div className="contact-v2-map">
                    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.821789359885!2d72.87756927503749!3d21.238914280463494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f705dffe915%3A0x1fc83e2ebcf890f5!2sTulsi%20Arcade!5e0!3m2!1sen!2sin!4v1770321411026!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.821789359885!2d72.87756927503749!3d21.238914280463494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f705dffe915%3A0x1fc83e2ebcf890f5!2sTulsi%20Arcade!5e0!3m2!1sen!2sin!4v1770321411026!5m2!1sen!2sin"
                      width="600"
                      height="450"
                      style={{ border: 0 }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6} md={12} className="d-flex">
              <div className="contact-v2-panel w-100">
                <div className="contact-v2-panelInner h-100 d-flex flex-column">
                  <Form
                    className="contact-v2-form"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                    // onSubmit={handleSubmit}
                  >
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Label className="contact-v2-formLabel">
                          Your Name
                        </Form.Label>
                        <Form.Control
                          className="contact-v2-input"
                          name="fullName"
                          value={formValues.fullName}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={6}>
                        <Form.Label className="contact-v2-formLabel">
                          Your Email
                        </Form.Label>
                        <Form.Control
                          className="contact-v2-input"
                          name="email"
                          type="email"
                          value={formValues.email}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={12}>
                        <Form.Label className="contact-v2-formLabel">
                          Subject
                        </Form.Label>
                        <Form.Control
                          className="contact-v2-input"
                          name="subject"
                          value={formValues.subject}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={12}>
                        <Form.Label className="contact-v2-formLabel">
                          Message
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={8}
                          className="contact-v2-input"
                          name="message"
                          value={formValues.message}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={12} className="text-center pt-2">
                        <Button type="submit" className="contact-v2-submit">
                          Send Message
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <Footer />
      </div>
    </>
  );
}

export default ContactUs;
